// extracted by mini-css-extract-plugin
module.exports = {"scroll-indicator":"ScrollIndicator_scroll-indicator__2bNyQ","is-hidden":"ScrollIndicator_is-hidden__3tTi_","scroll-down-icon":"ScrollIndicator_scroll-down-icon__gV_sq"};